export const ORGID_PATH_PARAM = 'orgid';
export const PRODUCTID_PATH_PARAM = 'productId';
export const ISSUEID_PATH_PARAM = 'issueId';
export const FEATUREID_PATH_PARAM = 'featureId';
export const VALUESTREAMID_PATH_PARAM = 'valueStreamId';
export const INITIATIVEID_PATH_PARAM = 'initiativeId';
export const PROJECTID_PATH_PARAM = 'projectId';
export const PROJECTS_FETCH_ENDPOINT = 'projects';
export const PROJECT_ADD_ENDPOINT = 'addProject';
export const PROJECTS_ADD_ENDPOINT = 'addProjects';
export const PROJECT_UPDATE_ENDPOINT = 'updateProject';
export const PROJECT_BUS_PRIORITIES_UPDATE_ENDPOINT = 'updateBusPriorities';
export const PROJECT_BUS_PRIORITIES_DELETE_ENDPOINT = 'deleteBusPriorities';
export const PROJECT_COST_PRIORITIES_UPDATE_ENDPOINT = 'updateCostPriorities';
export const PROJECT_COST_PRIORITIES_DELETE_ENDPOINT = 'deleteCostPriorities';
export const ORGANISATION_STATISTICS = 'organisationStatistics';
export const ADD_ORGANISATION = 'addOrganisation';
export const UPDATE_ORGANISATION = 'updateOrganisation';
export const EMPLOYEE_FETCH_ENDPOINT = 'employees';
export const EMPLOYEE_UPDATE_ENDPOINT = 'updateEmployee';
export const EMPLOYEE_ADD_ENDPOINT = 'addEmployee';
export const ORG_SURVEY_ANSWERS_ENDPOINT = 'organisationSurveyAnswers';
export const COMPARE_ORG_SURVEY_ANSWERS_ENDPOINT = 'compareOrgSurveyAnswers';

export const JIRA_GET_PROJECTS_ENDPOINT = 'importJiraProjects';


// WEBPACK FOOTER //
// ./constants/api.js